import { Construction } from "lucide-react";

interface MaintenanceModeProps {
  message: string;
}

export function MaintenanceMode({ message }: MaintenanceModeProps) {
  return (
    <div className="min-h-[65vh] flex items-center justify-center px-4 py-10">
      <section
        className="w-full max-w-3xl rounded-2xl overflow-hidden border-2 shadow-2xl"
        style={{ borderColor: "var(--unach-gold)" }}
      >
        <header
          className="px-6 py-10 text-center text-white"
          style={{ backgroundColor: "var(--unach-dark-blue)" }}
        >
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full border border-white/20 bg-white/10">
            <Construction className="h-8 w-8" style={{ color: "var(--unach-gold)" }} />
          </div>
          <h1 className="text-2xl font-black uppercase tracking-wide md:text-3xl">
            Sistema en Mantenimiento
          </h1>
          <p className="mt-3 text-sm text-slate-100 md:text-base">
            El portal público no está disponible temporalmente.
          </p>
        </header>

        <div className="bg-white px-6 py-8 text-center">
          <p className="leading-relaxed text-gray-700">
            {message?.trim() || "Estamos realizando mejoras. Por favor, inténtalo más tarde."}
          </p>
        </div>
      </section>
    </div>
  );
}
